var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOvertimeClaims(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.521,
    height: 31.517,
    viewBox: "0 0 31.521 31.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-transport-1575497",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11442",
    "data-name": "Path 11442",
    d: "M115.573,204.651a.526.526,0,0,0-.444-.245h-4.518v-2.627a.525.525,0,0,0-.525-.525H94.325a.525.525,0,0,0-.525.525v1.576H91.7a.525.525,0,0,0,0,1.051h2.1v4.728H88.021a.525.525,0,0,0,0,1.051H93.8v5.253H89.072a.525.525,0,0,0,0,1.051H93.8v1.051a.525.525,0,0,0,.525.525H96.5a2.091,2.091,0,0,0,4.054,0h11.706a2.091,2.091,0,0,0,4.054,0h2.176a.525.525,0,0,0,.525-.525v-7.274a.526.526,0,0,0-.081-.28ZM98.528,218.59a1.051,1.051,0,1,1,.743-.308A1.051,1.051,0,0,1,98.528,218.59Zm0-3.152a2.1,2.1,0,0,0-2.027,1.576H94.851V202.3h14.71v14.71h-9.005a2.1,2.1,0,0,0-2.027-1.576Zm15.76,3.152a1.051,1.051,0,1,1,.743-.308A1.051,1.051,0,0,1,114.288,218.59Zm3.677-1.576h-1.651a2.091,2.091,0,0,0-4.054,0h-1.651V205.457h4.228l3.127,4.961Z",
    transform: "translate(-87.496 -190.225)",
    fill: "#d8d58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11443",
    "data-name": "Path 11443",
    d: "M289.275,265.736h4.511l-1.2,1.2h0a.525.525,0,1,0,.743.743l2.1-2.1a.525.525,0,0,0,0-.744l-2.1-2.1a.525.525,0,0,0-.743.743l1.2,1.206h-4.511a.525.525,0,1,0,0,1.051Z",
    transform: "translate(-276.667 -247.878)",
    fill: "#d8d58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11444",
    "data-name": "Path 11444",
    d: "M256.743,336.956l-1.2-1.2h4.511a.525.525,0,1,0,0-1.051h-4.511l1.2-1.2h0a.525.525,0,0,0-.743-.743l-2.1,2.1a.525.525,0,0,0,0,.744l2.1,2.1a.525.525,0,0,0,.743-.743Z",
    transform: "translate(-243.763 -313.69)",
    fill: "#d8d58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11445",
    "data-name": "Path 11445",
    d: "M105.525,237.3h.525a.525.525,0,1,0,0-1.051h-.525a.525.525,0,1,0,0,1.051Z",
    transform: "translate(-103.949 -223.12)",
    fill: "#d8d58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11446",
    "data-name": "Path 11446",
    d: "M118.5,525H88.025a.525.525,0,1,0,0,1.051H118.5a.525.525,0,1,0,0-1.051Z",
    transform: "translate(-87.5 -494.534)",
    fill: "#d8d58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11447",
    "data-name": "Path 11447",
    d: "M491.576,376.25h-1.051a.525.525,0,0,0,0,1.051h1.051a.525.525,0,0,0,0-1.051Z",
    transform: "translate(-465.834 -354.714)",
    fill: "#d8d58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11448",
    "data-name": "Path 11448",
    d: "M492.369,288.75H490.53a.525.525,0,0,0-.525.525v3.152a.525.525,0,0,0,.525.525h3.677a.525.525,0,0,0,.454-.788l-1.839-3.152A.525.525,0,0,0,492.369,288.75Zm-1.313,3.152v-2.1h1.012l1.226,2.1Z",
    transform: "translate(-465.839 -272.468)",
    fill: "#d8d58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11449",
    "data-name": "Path 11449",
    d: "M480.276,18.312a4.3,4.3,0,0,1-3.072-.535l-.23-.139h0a.443.443,0,0,0-.045-.019l-.046-.02a.521.521,0,0,0-.361,0l-.046.02-.045.019-.231.139h0a4.291,4.291,0,0,1-3.069.535.525.525,0,0,0-.63.515v5.29h0a4.133,4.133,0,0,0,.583,2.117,4.078,4.078,0,0,0,1.9,1.667l1.512.652h0a.522.522,0,0,0,.413,0l1.512-.652h0a4.076,4.076,0,0,0,1.9-1.667,4.132,4.132,0,0,0,.586-2.117v-5.29a.525.525,0,0,0-.63-.515Zm-6.29,7.383a3.081,3.081,0,0,1-.434-1.576V19.43a5.324,5.324,0,0,0,2.627-.461v8.3l-.779-.336a3.036,3.036,0,0,1-1.413-1.24Zm5.87-1.576a3.081,3.081,0,0,1-.434,1.576,3.035,3.035,0,0,1-1.413,1.24l-.779.336v-8.3a5.324,5.324,0,0,0,2.627.461Z",
    transform: "translate(-449.385 -17.566)",
    fill: "#d8d58c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvertimeClaims);
export default __webpack_public_path__ + "static/media/OvertimeClaims.8fd5405f2f71e86c9bd2e2dfb1716aee.svg";
export { ForwardRef as ReactComponent };